// require (not import): an ES import would make this file strict mode, and `quill = ...` below is an implicit global
const { escapeHtml } = require('./functions');
require('./tomselect-checkboxes'); // the fx_checkbox_untabbable TomSelect plugin

if (document.querySelector(".products-create") || document.querySelector(".products-edit")) {
    quill = new Quill("#description", {
        modules: {
            toolbar: [
                ['bold', 'italic', 'underline'],
            ],
        },
        // Only text formatting the order emails can show. No image/video embeds, so a stored
        // <img src> is dropped instead of being fetched by whoever opens the editor.
        formats: ['bold', 'italic', 'underline', 'strike', 'link', 'list', 'header', 'blockquote'],
        theme: "snow",
        placeholder: "Describe the product (optional)",
    });
    const descriptionTextarea = document.getElementById("descriptionTextarea");
    // Load the stored HTML through Quill's clipboard (parsed in an inert DOMParser document and
    // rebuilt from Quill's own formats), never via innerHTML, so stored markup cannot run script.
    // Loaded before the listener is attached, so an untouched editor submits the stored value as is.
    quill.setContents(quill.clipboard.convert({ html: descriptionTextarea.value }), 'silent');
    quill.on('text-change', function () {
        descriptionTextarea.value = quill.getText().trim() === '' ? '' : quill.root.innerHTML;
    });
    new TomSelect(document.querySelector("#productTags"), {
        maxItems: null,
        plugins: {
            'checkbox_options': {
                'checkedClassNames':   ['ts-checked'],
                'uncheckedClassNames': ['ts-unchecked'],
            },
            'fx_checkbox_untabbable': {}, // (after checkbox_options: Tab leaves the field)
        },
        allowEmptyOption: true,
    });

    let fetchProductButton = document.getElementById('fetchProductButton');
    if (fetchProductButton) {
        fetchProductButton.addEventListener('click', function (e) {
            const searchProductName = encodeURIComponent(document.getElementById('quickbooks_product_name').value);
            axios.get(`/quickbooks/find-products-by-name/${searchProductName}`)
                .then(response => {
                    let data = response.data;
                    let searchProductsList = document.getElementById('searchProductsList');
                    searchProductsList.innerHTML = '';
                    document.getElementById('searchProductsDetails').style.display = 'block';

                    if (Array.isArray(data) && data.length > 0) {
                        data.forEach((product, index) => {
                            let row = document.createElement('div');
                            row.className = 'fx-qb-result';
                            row.innerHTML = `
                                <span class="fx-qb-result__index">${index + 1}.</span>
                                <span class="fx-qb-result__name">${escapeHtml(product.name)}</span>
                                <button type="button" class="btn btn-soft-primary btn-mc select-product-btn" data-id="${escapeHtml(product.qb_id)}">Select</button>
                            `;
                            searchProductsList.appendChild(row);
                        });

                        document.querySelectorAll('.select-product-btn').forEach(button => {
                            button.addEventListener('click', () => {
                                document.getElementById('external_id').value = button.getAttribute('data-id');
                            });
                        });
                    } else {
                        document.getElementById('searchProductsDetails').style.display = 'block';
                        let searchProductsList = document.getElementById('searchProductsList');
                        searchProductsList.innerHTML = '';
                        let row = document.createElement('div');
                        row.className = 'fx-qb-result fx-qb-result--empty';
                        row.innerHTML = `<span>No products found</span>`;
                        searchProductsList.appendChild(row);
                    }
                })
                .catch(error => {
                    console.error('Error fetching product:', error);
                    document.getElementById('searchProductsDetails').style.display = 'block';
                    let searchProductsList = document.getElementById('searchProductsList');
                    searchProductsList.innerHTML = '';
                    let row = document.createElement('div');
                    row.className = 'fx-qb-result fx-qb-result--empty';
                    row.innerHTML = `<span>QuickBooks search failed. Please try again.</span>`;
                    searchProductsList.appendChild(row);
                });
        });
    }

    document.querySelectorAll('.select-product-btn').forEach(button => {
        button.addEventListener('click', () => {
            document.getElementById('external_id').value = button.getAttribute('data-id');
        });
    });
}
